import styled from 'styled-components'
import { COLOR } from 'src/service/constant/color'
import arrow_icon from 'src/assets/main/main8/swiper-arrow.png'
import {customMedia} from "src/styles/common/common";

const Main6SectionWrap = styled.div`
  width: 100%;
  ${customMedia.lessThan('tablet')`
    max-width:768px;
    width: 100%;
    margin: 0 auto;
`}
`
const Main6TopContent = styled.div`
  width: 100%;
  text-align: center;
  display: block;

  > h3 {
    font-family: NanumSquareNeoExtraBold, sans-serif;
    margin: 234px 0 26px 0;
    font-size: 60px;
    line-height: 66px;
    //margin: 0;
  }

  > p {
    font-family: NotoSansRegular, sans-serif;
    margin: 0 auto 57px auto;
    font-size: 20px;
    line-height: 29px;
    
  }

  ${customMedia.lessThan('tablet')`
    >h3{
      margin: 75px 0 16px 0;
      font-size: 24px;
      line-height: 27px;
    }
    >p{
      margin: 0 0 40px 0;
      font-size: 14px;
      line-height: 20px;
      padding: 0 16px;
    }
`}
`
const Main6BottomContent = styled.div`
  display: block;
  width: 1100px;
  margin: 0 auto;

  > section {
    margin: 0 auto;
    display: flex;
  }

  > div {
    margin: 0 auto 79px auto;
    display: flex;
    justify-content: space-between;
    ${customMedia.lessThan('tablet')`
        margin: 0 auto;
    `}
  }

  ${customMedia.lessThan('tablet')`
   >section{
    display: flex;
    justify-content: center;
    width: 296px;
   }
    max-width:768px;
    width:100%:
`}
  ${customMedia.lessThan('main6')`
   width: 100%;
   overflow: hidden;
   
   .swiper-button-prev, .swiper-button-next {
    opacity: 0.7;
    cursor: pointer;
    display: flex;
    width: 60px;
    height: 60px;
    background-image: url(${arrow_icon});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    position: absolute;
    top: 36%;
    z-index: 10;
  }

  .swiper-button-prev {
    left: 0;
  }

  .swiper-button-next {
    right: 0;
    transform: rotate(180deg);
  }
`}
`
const Main6BottomBtn = styled.button`
  width: 70px;
  height: 39px;
  margin: 0 12px 20px 0;
  border: none;
  background: ${(props) => props.color === 'active' ? COLOR.gray90 : COLOR.gray10};
  border-radius: 20px;
  color: ${(props) => props.color === 'active' ? COLOR.white : COLOR.black};
  font-size: 16px;
  line-height: 39px;
  padding:0;
  font-family: NotoSansBold, sans-serif;
`
const Main6BottomItem = styled.div<{cursorActive: string}>`
  width: 356px;
  cursor: ${(props) => props.cursorActive};

  > img {
    display: flex;
    width: 100%;
    height: 267px;
  }

  > p {
    margin: 20px 0 0 0;
    font-family: NotoSansBold, sans-serif;
    font-size: 16px;
    line-height: 23px;
  }

  ${customMedia.lessThan('tablet')`
    width: 240px;
    margin: 0 0 48px 0;
    box-shadow: 0px 1px 12px rgba(0, 0, 0, 0.12);
    border-radius: 32px;
    >img{
      height:198px;
    }
    >p{
      margin: 12px 21px 15px 21px;
    }
`}
  ${customMedia.lessThan('main6')`
   width: 240px;
   overflow: hidden;
`}
`
export {
  Main6SectionWrap,
  Main6TopContent,
  Main6BottomContent,
  Main6BottomItem,
  Main6BottomBtn
}
